import { Grid, MultiSelectBaseProps, MultiSelectBase, ColorSwatchButton, Text, Stack } from '@stitch-fix/mode-react';
import { ReactNode } from 'react';
import { FreestyleSearchFilterColorOption } from '../../../types/definitions/vendor/graphql-schema.d';
export type ColorOption = Pick<FreestyleSearchFilterColorOption, 'hex' | 'label' | 'selected' | 'value'>;
type ColorFilterProps = {
  id: MultiSelectBaseProps['name'];
  setSelectedValues: MultiSelectBaseProps['onChange'];
  options: ColorOption[];
  selectedValues: MultiSelectBaseProps['value'];
};
const container = (children: ReactNode) => <Grid columns={4} spacing="wide">
    <>{children}</>
  </Grid>;

/**
 * Displays a grid of selectable color swatches.
 */
const ColorFilter = ({
  id,
  selectedValues,
  setSelectedValues,
  options
}: ColorFilterProps) => {
  return <MultiSelectBase container={container} options={options} name={id} value={selectedValues} onChange={setSelectedValues}>
      {({
      isSelected,
      value,
      ...selectableProps
    }, currentOption) => <Stack spacing={0} hAlign="center">
          <ColorSwatchButton label={currentOption.label} hex={currentOption.hex} isSelected={isSelected} value={value} hideTooltip {...selectableProps} />
          <Text setting="body-small">
            {isSelected ? <strong>{currentOption.label}</strong> : currentOption.label}
          </Text>
        </Stack>}
    </MultiSelectBase>;
};
export default ColorFilter;